/* eslint-disable */
import { FlagColorType } from "@components/global/new/MinerFlag/useMinerFlagControl";
import { SpeedFilterValue } from "@components/Pages/Machines/Filters/SpeedFilter/SpeedFilter";
import { MinerSortFields } from "@components/Pages/Machines/MinersTable/useMinersTableControl";
import { ALGOS_E } from "@constants/Algos";
import {
  MINER_STATUSES_E,
  MinerFilterableStatus,
} from "@constants/MinerStatuses";
import { calculateHash } from "@utils/hash.utils";
import { GetRequest, PostRequest } from "./http/BaseRequest";
import { IPlanContract } from "./http/responses/AccountResponse";
import { MinerTabType } from "./http/responses/BaseResponse";
import W2UiFilterBuilder from "./w2ui";
import { SearchItem, SortItem } from "./w2ui/w2const";
import { Search } from "./w2ui/w2filter";

export const FILTERABLE_STATUSES_TITLE: Record<MinerFilterableStatus, string> =
  {
    [MINER_STATUSES_E.UNKNOWN]: "Unknown",
    [MINER_STATUSES_E.OK]: "Ok",
    [MINER_STATUSES_E.LOW]: "Low",
    [MINER_STATUSES_E.BAD]: "Bad",
    [MINER_STATUSES_E.PAUSED]: "Paused",
    [MINER_STATUSES_E.STOPPED]: "Stopped",
    [MINER_STATUSES_E.FAIL]: "Connection fault!",
    [MINER_STATUSES_E.OFF]: "Offline",
    [MINER_STATUSES_E.STOPPING]: "Stopping...",
    [MINER_STATUSES_E.STARTING]: "Starting...",
    [MINER_STATUSES_E.WARNING]: "Warning",
    [MINER_STATUSES_E.PENDING]: "Pending...",
  } as const;

export const STATUSES_TITLE: Record<MINER_STATUSES_E, string> = {
  [MINER_STATUSES_E.UNKNOWN]: "Unknown",
  [MINER_STATUSES_E.OK]: "Ok",
  [MINER_STATUSES_E.LOW]: "Low",
  [MINER_STATUSES_E.BAD]: "Bad",
  [MINER_STATUSES_E.PAUSED]: "Paused",
  [MINER_STATUSES_E.STOPPED]: "Stopped",
  [MINER_STATUSES_E.FAIL]: "Connection fault!",
  [MINER_STATUSES_E.OFF]: "Offline",
  [MINER_STATUSES_E.STOPPING]: "Stopping...",
  [MINER_STATUSES_E.STARTING]: "Starting...",
  [MINER_STATUSES_E.WARNING]: "Warning",
  [MINER_STATUSES_E.PENDING]: "Pending...",
  //[MINER_STATUSES_E.FAULT]: "Error",
} as const;

export enum MINER_SETTINGS_E {
  MINER = "miner",
  MINER_ID = "miner_id",
  STATUS = "miner_status",
  POOL = "pool_id",
  CUSTOMER = "customer",
  MINER_PROFILE = "profile_id",
  SPEED_DEFAULT = "default_speed",
  ADMIN_PERCENT = "mining_persent",
  ADMIN_SETTING = "admin_setting",
  SPEED_DROPS = "speed_drops",
  ADMIN_TEXT = "admin_text",
  USER_NOTE = "user_note",
  ADMIN_NOTES = "admin_notes",
  MINER_LOCATION = "miner_location",
  MINER_LOCATION_ID = "location_id",
  MINER_SMOOTH = "miner_smooth",
  MINER_SERIAL = "sn",
  MINER_MODEL = "pn",
  MINER_PHOTO = "photo",
  MINER_CONTRACT = "contractid",
  MINER_PLAN = "miner_plan",
  MINER_INSTALATION_DATE = "set_install_time",
  USER_CODE = "userUuid",
}

export interface NoteI {
  id: string | number;
  text: string;
  date: number;
}

export interface IPlanRange {
  id: number;
  time: [string, string];
  active: boolean;
  priority: number; // higher value means higher priority
}

export interface IDaySchedule {
  readonly day: string;
  readonly color: string;
  readonly range: IPlanRange[];
}

export interface IMiningPlanOptions {
  id: number;
  name: string;
  schedule: IDaySchedule[];
  contracts?: IPlanContract[];
  meta: string; //JSON
}

export const isMiningPlanOptionsI = (x: any): x is IMiningPlanOptions => {
  const y = x as IMiningPlanOptions;
  if (y.id === undefined || y.name === undefined || y.schedule === undefined)
    return false;
  return true;
};

export const DEFAULT_PLAN: IMiningPlanOptions = {
  schedule: [],
  id: 3,
  name: "default",
  meta: "",
};

interface MinerLocationBase {
  name: string;
  address: string;
}

export interface MinerLocationRaw extends MinerLocationBase {
  id: string;
  location_id: string;
}

export interface MinerLocation extends MinerLocationBase {
  id: number;
}

export function locationFromRaw(loc: MinerLocationRaw): MinerLocation {
  return { ...loc, id: +loc.id };
}

export enum PoolChangesEventE {
  CUSTOMER = 0,
  POOL = 1,
}
export interface IPoolChangesLog {
  date: number;
  pool: string;
  // if admin
  customer_email?: string;
  customer_name?: string;
  event?: PoolChangesEventE;
}

// export interface ReceivedMinerDataI {
//   id: number;
//   miner_id: string;
//   unknown_miner_id?: string;
//   profile: IMinerProfileBase;
//   hash: ALGOS_E;
//   speed_default: number;
//   speed_current: number;
//   accepted?: number;
//   rejected?: number;
//   speed_drop: number;
//   setting: string;
//   settingid: number;
//   status: MINER_STATUSES_E;
//   location: string;
//   location_id: string;
//   tags?: string;
//   user_color?: string;
//   node?: string;
//   ///
//   customer_uuid?: string;
//   customer_id?: string;
//   customer_email?: string;
//   customer_name?: string;
//   admin_mining_do?: boolean;
//   has_errors?: boolean;
// }

export interface IAdminMinerProof {
  day: string;
  range: number[][];
}

export interface IReproxyLink {
  Port: number;
  Target: string;
  LastActive: string;
}

export interface IReproxyPortDesc {
  readonly Id: number; //miner id
  readonly Desc: string;
}
export interface IReproxyPort {
  Port: number;
  Target: string;
  TargetId: string; // miner id
  TargetDesc: string; // JSON IReproxyPortDesc
  LastActive: string;
}

/*
export interface MinerTableResponseI extends ServerResponse {
  Records: IAdminMinerTable[];
  Total: number;
}
*/
export interface MTFiltersValuesI {
  f_admin_mine?: boolean;
  f_customer?: string;
  f_setting_id?: string;
  f_type?: string;
  f_mining_rate?: string;
  f_state?: MINER_STATUSES_E[];
  f_hash?: ALGOS_E;
  f_location?: string;
  f_mining_percent?: number;
  f_speed_less?: number;
  f_speed_more?: number;
  f_speeddrop?: number;
  search?: string[];
  f_speed_default_less?: number;
  f_speed_default_more?: number;
  f_instalation_date_less?: number;
  f_instalation_date_more?: number;
  f_customer_tags?: string;
  f_building?: string;
  f_planid?: number; // - поиск майнеров с указанным планом
  f_contractid?: number; // - поиск майнеров с указанным контрактом
  f_flags?: FlagColorType;
  f_has_errors?: boolean;
  f_withoutflag?: boolean;
  f_withoutplan?: boolean;
  f_withoutcontract?: boolean;
  //
  f_with_dup_ip?: boolean;
  f_with_dup_mac?: boolean;
}

export const equalFilters = (
  a?: MTFiltersValuesI,
  b?: MTFiltersValuesI
): boolean => {
  if (a === undefined && b === undefined) return true;
  if (a === undefined || b === undefined) return false;

  const keys: Set<keyof MTFiltersValuesI> = new Set();
  for (const k of Object.getOwnPropertyNames(a))
    if (k.startsWith("f_")) keys.add(k as keyof MTFiltersValuesI);
  for (const k of Object.getOwnPropertyNames(b))
    if (k.startsWith("f_")) keys.add(k as keyof MTFiltersValuesI);
  for (const k of Array.from(keys)) {
    if (a[k] !== b[k]) return false;
  }
  const sA = a.search ? new Set(a.search) : new Set();
  const sB = b.search ? new Set(b.search) : new Set();
  if (sA.size !== sB.size) return false;
  for (const s of Array.from(sA)) {
    if (!sB.has(s)) return false;
    else sB.delete(s);
  }
  if (sB.size) return false;
  return true;
};

export enum MTSort {
  Unset = 0,
  ID,
  Algo,
  SpeedDefault,
  SpeedCurrent,
  Settings,
  State,
  Customer,
  Type,
}

export const MinersSortToFields: Record<MTSort, MinerSortFields> = {
  [MTSort.Unset]: MinerSortFields.UNSET,
  [MTSort.ID]: MinerSortFields.ID,
  [MTSort.Algo]: MinerSortFields.ALGO,
  [MTSort.SpeedDefault]: MinerSortFields.SPEED_D,
  [MTSort.SpeedCurrent]: MinerSortFields.SPEED_C,
  [MTSort.Settings]: MinerSortFields.POOL,
  [MTSort.State]: MinerSortFields.STATE,
  [MTSort.Customer]: MinerSortFields.CUSTOMER,
  [MTSort.Type]: MinerSortFields.TYPE,
};

export type MinersSortState = [MTSort, SortDirection];

export function serverSortingCode(s: MinersSortState): MinerSortFields {
  return MinersSortToFields[s[0]];
}

export const SortFieldsToMinersSort = Object.fromEntries(
  Object.entries(MinersSortToFields).map(([a, b]) => [b, +a])
) as Record<MinerSortFields, MTSort>;

export enum SortDirection {
  Unset = 0,
  Asc,
  Desc,
}

class GetMinersList extends PostRequest {
  constructor(
    uri: string,
    offset = 0,
    limit = 20,
    filter?: MTFiltersValuesI,
    sort?: MTSort,
    dir?: SortDirection
  ) {
    const params: any = {
      offset,
      limit,
      ...filter,
      search: JSON.stringify(filter?.search),
    };
    if (sort !== undefined) {
      params.sort = sort;
      params.dir = dir;
      if (!dir) {
        params.dir = SortDirection.Asc;
      }
    }
    super(uri, params);
  }
}

const searchOpsTable: Partial<
  Record<keyof MTFiltersValuesI, (f: string, v: any) => Search>
> = {
  f_setting_id: SearchItem.textIs,
  f_customer: SearchItem.textIs,
  f_type: SearchItem.textIs,
  f_mining_rate: SearchItem.textIs,
  f_hash: SearchItem.textIs,

  f_speed_default_more: SearchItem.floatMore,
  f_speed_default_less: SearchItem.floatLess,

  f_speed_more: SearchItem.floatMore,
  f_speed_less: SearchItem.floatLess,

  f_speeddrop: SearchItem.floatMore,

  f_mining_percent: SearchItem.floatLess,

  f_state: SearchItem.intIn,
  f_location: SearchItem.intIs,
  f_building: SearchItem.intIn,
  f_customer_tags: SearchItem.textIn,
  f_instalation_date_less: SearchItem.intBetween,
  f_instalation_date_more: SearchItem.intBetween,
  f_admin_mine: SearchItem.booleanIs,
  f_has_errors: SearchItem.booleanIs,
  f_withoutflag: SearchItem.booleanIs,
  f_withoutplan: SearchItem.booleanIs,
  f_withoutcontract: SearchItem.booleanIs,
  f_flags: SearchItem.textIn,

  f_contractid: SearchItem.intIs,
  f_planid: SearchItem.intIs,

  search: SearchItem.textContains,
};

type sortField =
  | "fr_minerid"
  | "f_hash"
  | "f_speeddefault"
  | "f_speed"
  | "f_setting_id"
  | "f_state"
  | "f_customer"
  | "f_type";

const sortOpsTable: Record<MTSort, sortField> = {
  [MTSort.Unset]: "f_state",
  [MTSort.ID]: "fr_minerid",
  [MTSort.Algo]: "f_hash",
  [MTSort.SpeedDefault]: "f_speeddefault",
  [MTSort.SpeedCurrent]: "f_speed",
  [MTSort.Settings]: "f_setting_id",
  [MTSort.State]: "f_state",
  [MTSort.Customer]: "f_customer",
  [MTSort.Type]: "f_type",
};

export const MoveTargetTabs: ReadonlySet<string> = new Set([
  "broken",
  "storage",
  "excluded",
]);

const normalizeMinerSearch = (search?: string[]) =>
  search?.flatMap((value) =>
    value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
  );

const toUnix = (t: number) => Math.ceil(t / 1000);
class GetMinersList2 extends PostRequest {
  constructor(
    uri: string,
    offset = 0,
    limit = 20,
    filter?: MTFiltersValuesI,
    sort?: MTSort,
    dir?: SortDirection,
    tab?: MinerTabType
  ) {
    if (filter?.search) {
      const originalSearch = filter.search;
      filter = {
        ...filter,
        search: normalizeMinerSearch(originalSearch),
      };
      /*dbg.log("GET_MINERS_LIST_SEARCH", JSON.stringify({
        originalSearch,
        normalizedSearch: filter.search,
      }));*/
    }

    const tabl = tab ? [tab] : tab;
    const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset);
    let params = "";
    if (tab === "unknown") {
      uri += "/unknown";
      if (filter?.search?.length)
        builder.addSearch(SearchItem.textContains("f_search", filter.search));
      params = builder.build().stringParams;
    } else {
      if (sort) {
        const op = dir === SortDirection.Desc ? SortItem.desc : SortItem.asc;
        builder.setSort([op(sortOpsTable[sort])]);
      }
      if (tab) {
        if (typeof tab === "string")
          builder.addSearch(SearchItem.inList("f_tab", tabl));
        else if (typeof tab === "number")
          builder.addSearch(SearchItem.intIs("f_vtabid", tab));
      }
      if (filter) {
        let intervalIsSet = false;
        for (const field in searchOpsTable) {
          let fld = field as keyof MTFiltersValuesI;
          if (
            fld === "f_customer_tags" ||
            fld === "f_withoutcontract" ||
            fld === "f_withoutflag" ||
            fld === "f_withoutplan"
          ) {
            continue;
          }
          const op = searchOpsTable[fld];
          if (op === undefined) continue;
          if (fld === "search")
            filter[fld] = filter[fld]?.map((v) => v.replaceAll("-", ""));
          let filterVal = filter[fld];
          if (filterVal === undefined) continue;
          if (
            [
              "f_speed_less",
              "f_speed_more",
              "f_speed_default_less",
              "f_speed_default_more",
            ].includes(fld)
          ) {
            const [v, d] = filterVal as SpeedFilterValue;
            if (!+v) continue;
            filterVal = d ? calculateHash(+v, d) : v;
          } else if (fld === "f_building") {
            if (typeof filterVal === "number") {
              filterVal = `${filterVal}`;
            }
            filterVal = (filterVal as string).split(",");
          } else if (
            fld === "f_instalation_date_less" ||
            fld === "f_instalation_date_more"
          ) {
            if (intervalIsSet) continue;
            filterVal = [
              filter!.f_instalation_date_less === undefined
                ? `1`
                : `${toUnix(filter.f_instalation_date_less)}`,
              filter!.f_instalation_date_more === undefined
                ? `${toUnix(new Date().getTime() + 1000000)}`
                : `${toUnix(filter.f_instalation_date_more)}`,
            ];
            intervalIsSet = true;
          } else if (fld === "f_admin_mine" || fld === "f_has_errors") {
            if (!filterVal) continue;
            filterVal = `${filterVal}`;
          }
          if (Array.isArray(filterVal) && filterVal.length === 0) continue;
          builder.addSearch(
            op(
              fld === "search"
                ? "f_search"
                : fld === "f_setting_id"
                  ? "f_setting_id"
                  : fld === "f_speed_less" || fld === "f_speed_more"
                    ? "f_speed"
                    : fld === "f_building"
                      ? "f_object"
                      : fld === "f_instalation_date_less" ||
                        fld === "f_instalation_date_more"
                        ? "f_install"
                        : fld === "f_speed_default_less" ||
                          fld === "f_speed_default_more"
                          ? "f_speeddefault"
                          : fld === "f_admin_mine"
                            ? "f_isadminmine"
                            : field,
              filterVal
            )
          );
        }
        if (filter.f_customer_tags !== undefined) {
          params = `f_tags=${filter.f_customer_tags}&`;
        }

        if (filter.f_withoutflag) {
          params += `f_withoutflag=${filter.f_withoutflag}&`;
        }

        if (filter.f_withoutplan) {
          params += `f_withoutplan=${filter.f_withoutplan}&`;
        }

        if (filter.f_withoutcontract) {
          params += `f_withoutcontract=${filter.f_withoutcontract}&`;
        }

        if (filter.f_with_dup_ip) {
          params += `f_with_dup_ip=${filter.f_with_dup_ip}&`;
        }

        if (filter.f_with_dup_mac) {
          params += `f_with_dup_mac=${filter.f_with_dup_mac}&`;
        }
      }

      if (params.length) params += builder.build().stringParams;
      else params = builder.build().stringParams;
    }

    super(uri, params);
  }
}

export class GetAdminMinersList extends GetMinersList2 {
  constructor(
    offset = 0,
    limit = 20,
    filter?: MTFiltersValuesI,
    sort?: MTSort,
    dir?: SortDirection,
    tab?: MinerTabType
  ) {
    //const uri = (typeof tab === "number" || tab === "unknown") ? "/admin/miner/list" : "/v2/admin/miner/list";
    //const uri = "/v2/admin/miner/list";
    const uri =
      tab === "unknown" ? "/admin/miner/list" : "/v2/admin/miner/list";

    super(uri, offset, limit, filter, sort, dir, tab);
  }
}

export class GetUserMinersList extends GetMinersList2 {
  constructor(
    offset = 0,
    limit = 20,
    filter?: MTFiltersValuesI,
    sort?: MTSort,
    dir?: SortDirection,
    tab?: MinerTabType
  ) {
    const uri =
      typeof tab === "number" || tab === "unknown"
        ? "/admin/miner/list"
        : "/v2/admin/miner/list";
    super("/v2/user/miner/list", offset, limit, filter, sort, dir, tab);
  }
}

export class FixMinersList extends GetRequest {
  constructor(isAdmin: boolean, ids: string[]) {
    super(
      `/${isAdmin ? "admin" : "user"}/miner/list/fix?ids=${encodeURIComponent(
        ids.join(",")
      )}`
    );
  }
}
